import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../../context/AppContext';
import constants from '../../constants';
import { canShare, isIOSorSafari, buildShareString } from '../../utils/share';
import classNames from 'classnames/bind';

import styles from './ModalShare.module.scss';

function ModalShare() {
  const { setHandleModal } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(
    canShare ? 'Compartilhar' : 'Copiar para área de transferência'
  );
  const [disabled, setDisabled] = useState(false);
  const [team, setTeam] = useState({});
  const cx = classNames.bind(styles);
  const { body } = document;

  const handleOpenShare = (data) => {
    setOpen(true);
    setTeam(data);
    body.style.overflow = 'hidden';
  };

  useEffect(() => {
    setHandleModal((state) => ({
      ...state,
      handleOpenShare,
    }));
  }, []); // eslint-disable-line

  const copyToClipboard = async (string) => {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(string);
    } else {
      return document.execCommand('copy', true, string);
    }
  };

  const enableShareButton = () => {
    setMessage(canShare ? 'Compartilhar' : 'Copiar para área de transferência');
    setDisabled(false);
  };

  const handleClickShare = () => {
    let options = {
      text: buildShareString(team),
    };

    if (!isIOSorSafari) {
      options = {
        ...options,
        title: constants.share.title,
        url: constants.share.url,
      };
    }

    if (canShare) {
      navigator.share({ ...options });
      setMessage('Compartilhado!');
    } else {
      copyToClipboard(options.text);
      setMessage('Copiado!');
    }

    setDisabled(true);
    setTimeout(enableShareButton, 2000);
  };

  const handleClose = () => {
    setOpen(false);
    body.style.overflow = 'auto';
  };

  return (
    team.athletes && (
      <section
        className={cx({
          wrapper: true,
          wrapperOpen: open,
        })}
      >
        <div className={styles.bcg} role="button" onClick={handleClose} />
        <div className={styles.container}>
          <h3 className={styles.title}>
            <div>Compartilhar</div>
            <button
              className={styles.close}
              type="button"
              onClick={handleClose}
              title="Fechar caixa de compartilhamento"
            />
          </h3>
          <div className={styles.text}>
            Minha avaliação de elenco
            <br />
            <b> {team.name} no Brasileirão 2025</b>
            {constants.evalOrder.map((val) => {
              const filtered = [...team.athletes]
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter((item) => item.eval === val);
              const goodToGo = filtered.length > 0;
              const label = constants.eval[val];
              return (
                goodToGo && (
                  <div
                    key={`ModalShare__key__label__${val}__${filtered[0].teamId}`}
                  >
                    <br />
                    {label.emoji} <em>{label.title}</em>
                    {filtered.map((athlete) => {
                      return (
                        <div key={`ModalShare__key__athlete__${athlete.id}`}>
                          {athlete.name} - {athlete.position.field}
                        </div>
                      );
                    })}
                  </div>
                )
              );
            })}
          </div>
          <div className={styles.footer}>
            <button
              className={cx({
                copy: true,
                copyDisabled: disabled,
              })}
              disabled={disabled}
              onClick={handleClickShare}
              type="button"
              title="Compartilhar"
            >
              {message}
            </button>
          </div>
        </div>
      </section>
    )
  );
}

export default ModalShare;
